export const UnknownServerErrorMessage =
  "A server error occurred, please try again";
